import { ActionReducerMap } from '@ngrx/store';
import { ClinicalState } from 'src/app/clinical/store/clinical.state';
import { performanceEvalReducer } from 'src/app/clinical/store/reducers/performance-eval.reducers';
import { clinicalReviewHistoryReducer } from './clinical-review-history.reducers';
import { searchAllClinicalReviewsReducer } from './search-all-clinical-reviews.reducers';

export const clinicalReducers: ActionReducerMap<ClinicalState> = {
    performanceEval: performanceEvalReducer,
    clinicalReviewHistory: clinicalReviewHistoryReducer,
    searchAllClinicalReviews: searchAllClinicalReviewsReducer
};
